import { render, staticRenderFns } from "./index.vue?vue&type=template&id=31a04e2c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=31a04e2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a04e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31a04e2c')) {
      api.createRecord('31a04e2c', component.options)
    } else {
      api.reload('31a04e2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=31a04e2c&scoped=true", function () {
      api.rerender('31a04e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/referral-rule/index.vue"
export default component.exports